<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter-hk"><b>Praise for the Writing of Gary Devon</b></p>
<p class="praise1"><b><i>Lost</i></b></p>
<p class="praise1"><b>Edgar Award Finalist</b></p>
<p class="normal">“<i>Lost</i> is the kind of novel that will play havoc with readers who enjoy a long night’s sleep. In fact, once you start this book, forget about sleeping, eating or whatever until you’re done. [Gary Devon] comes through with a book that deserves serious consideration as a minor American classic.” —<i>Philadelphia Daily News</i></p>
<p class="normal1">“One of the most original riveting pieces of storytelling in years.” —<i>The Atlanta Journal-Constitution</i></p>
<p class="normal1">“I’ve heard books described as gripping, and I might even have used the term myself. I don’t think I really knew that it meant though, until I picked up <i>Lost</i>…. The writing is remarkable, dark, and exquisite. <i>Lost</i> is a real find.” —<i>The Washington Post Book World</i></p>
<p class="normal1">“Gripping … Mr. Devon has written a novel of appealing originality.” —<i>The New York Times</i></p>
<p class="praise1"><i>Bad Desire</i></p>
<p class="normal1">“Devon follows his praised first novel, <i>Lost</i>, with an account of forbidden love and serial murder that thrills from intriguing start to chilling finish.” —<i>Publishers Weekly</i></p>
<p class="normal1">“From the masterly depiction of his ice-eyed killer to his chilling Hitchcockian ending, Gary Devon blows away every other psychological suspense writer around. <i>Bad Desire</i> is a stunner. Buy it. Or beg, borrow, steal it. But read it.” —Martha Grimes, <i>New York Times</i>–bestselling author</p>
<p class="normal1">“<i>Bad Desire</i> is a very good read. A fine psychological thriller.” —Mary Higgins Clark, <i>New York Times</i>–bestselling author</p>
<p class="normal1">“Gripping and suspenseful.” —Ira Levin, <i>New York Times</i>–bestselling author</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise.vue?70d2f708